module.exports = __webpack_public_path__ + "static/media/background.49e95b1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background.svg
// module id = 803
// module chunks = 0